import React from 'react'
import { parseString } from '../../utils/stringHelper';
import MiniUserDetail from '../MiniUserDetail/MiniUserDetail';
import styles from './AnalyticsInfo.module.scss';
import { useTranslation } from 'react-i18next';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';
import cx from 'classnames'
import { formatToDateString } from '../../utils/TimeUtil';


const AnalyticsViewer = ({ user, userId, views, latestViewDate, handleOpenUserInfo }) => {
  const { t } = useTranslation();
  const myRef = useAccessibleClick(handleOpenUserInfo);

  return (
    <div
      ref={myRef}
      tabIndex={0}
      className={cx(styles.viewerItem, styles.viewerItemClickable)}
      onClick={() => handleOpenUserInfo({ user, userId, views, latestViewDate })}
    >
      <div className={styles.viewerInfo}>
        {user ? (
          <MiniUserDetail
            classNames={{
              containerClassName: styles.profile,
            }}
            avatar={user.avatar}
            size="medium"
            name={parseString(user.name)}
          />
        ) : (
          <div className={styles.anonymousViewer}>
            <div className={styles.imageContainer}>
              <span tabIndex={0}>{views}</span>
            </div>
            <span tabIndex={0} className={styles.viewerName}>{parseString(user?.name) || t('views.anonymous')}</span>
          </div>
        )}
      </div>
      {latestViewDate && (
        <span 
          tabIndex={0} 
          className={styles.latestViewDate}
          title={`${t('views.latest_view')}: ${formatToDateString(latestViewDate, 'en-US', true)}`}
        >
          {formatToDateString(latestViewDate, 'en-US', false)}
        </span>
      )}
    </div>
  )
};

export default AnalyticsViewer;